import React, { useEffect } from "react";
import { Box, Button, Checkbox, Divider, FormControl, FormControlLabel, Table, TableHead, TableRow, TableBody, TableCell, CircularProgress, FormLabel, Grid, InputAdornment, Paper, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { useState, useRef, useMemo } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import InputStyle from "../../../assets/InputStyle";
import flagIcon from "../../../images/flagIcon.png";
import { Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '../../../images/upload.svg';
import AddIcon from '@mui/icons-material/Add';
import regex from "../../../utils/regex";
import NumberInput from "../../../utils/NumberInput";
import JoditEditor from "jodit-react";
import { enqueueSnackbar } from "notistack";
import { createProfile, uploadImages } from "../../../actions/userAuth";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutline } from "@mui/icons-material";
import Navbar from "../../Navbar";
import { Stack } from "@mui/system";
import { State, City, Country } from 'country-state-city';

const General = ({ setSelectedTab }) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => ({ ...state }));
    const [resume, setResume] = React.useState('');
    const [countryCode, setCountryCode] = useState([]);
    const [image, setImage] = React.useState('');
    const [name, setName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [mobileNumber, setMobileNumber] = React.useState('');
    const [nationality, setNationality] = React.useState('');
    const [gender, setGender] = React.useState('');
    const [experience, setExperience] = React.useState();

    const [dob, setDob] = React.useState('');
    const [skills, setSkills] = React.useState([]);
    const [languages, setLanguages] = React.useState([]);
    const [adhaarCardNumber, setAdhaarCardNumber] = React.useState('');
    const [pan, setPan] = React.useState('');
    const [gst, setGstNumber] = React.useState('');
    const [country, setCountry] = React.useState('');
    const [state, setState] = React.useState('');
    const [city, setCity] = React.useState('');
    const [pincode, setPincode] = React.useState('');
    const [address, setAddress] = React.useState('');

    const [linkedin, setLinkedin] = React.useState('');
    const [portfolio, setPortfolio] = React.useState('');
    const [skillLevel, setSkillLevel] = React.useState('');
    const [level, setLevel] = React.useState('');
    const [loading, setLoading] = useState(false);
    const [allSkills, setAllSkills] = React.useState([]);
    const [languageLevel, setLanguageLevel] = React.useState("");
    const [allLanguages, setAllLanguages] = React.useState([]);

    const [emailError, setEmailError] = useState(true);
    const [adhaarError, setAdhaarError] = useState(true);
    const [panError, setPanError] = useState(true);
    const [ifscError, setIfscError] = useState(true);
    const [value, setValue] = useState("");
    const [allCountryList, setAllCountryList] = useState([]);
    const [allStates, setAllStates] = useState([]);
    const [allCities, setAllCities] = useState([]);
    const editor = useRef(null);

    useEffect(() => {
        setImage(user?.avatar);
        setName(user?.name);
        setEmail(user?.email);
        setMobileNumber(user?.phone?.slice(-10));
        setCountryCode(user?.phone?.slice(0, -10));

        setNationality(user?.nationality);
        setGender(user?.gender);
        setExperience(user?.experience);
        setDob(user?.dateOfBirth?.split('T')[0]);
        setAllSkills(user?.skills);
        setAllLanguages(user?.languages);
        setGstNumber(user?.GST_Number);
        setPincode(user?.pinCode);
        setCountry(user?.country);
        setState(user?.state);
        setCity(user?.city);
        setPincode(user?.pinCode);
        setAddress(user?.address);
        setValue(user?.description);
        setLinkedin(user?.socialNetworks?.linkedIn);
        setPortfolio(user?.socialNetworks?.portFolio);
        setRelocation(user?.willingToRelocate ? "Yes" : "No")
        setAvailability(user?.availability)
        if (user?.uploadResume) {
            setResume(JSON.parse(user?.uploadResume));
        }
        // if(user?.specialities?.length > 0){
        //     setAllSpecialities(user?.specialities);
        // }
    }, [user]);

    useEffect(() => {
        setAllCountryList(Country.getAllCountries())
    }, [])

    const handleAddAllSkills = () => {
        if (!skills || !skillLevel) {
            enqueueSnackbar("Please select appropriate skills and level before adding", { variant: 'warning' });
        } else {
            setAllSkills(oldArr => [...oldArr, { skill: skills, skillLevel: skillLevel }]);
        }
        setSkills("");
        setSkillLevel("");
    }

    const handleChangeCountry = (e) => {
        setCountry(Country.getCountryByCode(e.target.value))
        setAllStates(State.getStatesOfCountry(e.target.value))
    }

    const handleChangeState = (e) => {
        setAllCities(City.getCitiesOfState(country.isoCode, e.target.value));
        setState(State.getStateByCodeAndCountry(e.target.value, country.isoCode).name);
    };

    const handleChangeCity = (e) => {
        setCity(e.target.value);
    };

    const uploadResume = (e) => {
        const file = e.target.files[0];
        if (file) {
            let formData = new FormData();
            formData.append("file", file);
            dispatch(uploadImages(formData, (data) => {
                let payload = {
                    name: file.name,
                    image: data.data.imagesKey[0]
                }
                setResume(payload);
            }, (err) => {
                enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
            }))
        }
    }

    const handleSubmit = () => {
        setLoading(true);
        if
            (!name || !image || !email || !mobileNumber || !country || !state || !city
        ) {
            enqueueSnackbar("Please fill in all the required fields", { variant: 'warning' });
            setLoading(false);
            return;
        } else {

            let payload = {
                avatar: image,
                uploadResume: resume ? JSON.stringify(resume) : "",
                fullName: name,
                email,
                mobileNumber,
                nationality,
                gender,
                experience,
                dateOfBirth: dob,
                skills: allSkills,
                languages: allLanguages,
                country: country?.name,
                state,
                city,
                pincode,
                address,
                description: value,
                willingToRelocate: relocation === 'Yes',
                availability: [availability],
                socialNetworks: {
                    linkedIn: linkedin,
                    portFolio: portfolio,
                }
            }
            let role = JSON.parse(localStorage.getItem("user"));
            dispatch(createProfile(payload, role._id, role.role, (data) => {
                console.log(data)
                enqueueSnackbar(data.data.message, { variant: 'success' });
                setLoading(false);
                setSelectedTab(1);
            }, (err) => {
                setLoading(false);
                enqueueSnackbar("Error Occured! please try again", { variant: 'warning' });
            }, localStorage.getItem("refreshToken")))
        }
    }

    React.useEffect(() => {
        if (email) {
            const isEmailValid = regex.emailPattern.test(email)
            setEmailError(isEmailValid)
        }
    }, [email])

    React.useEffect(() => {
        if (adhaarCardNumber) {
            const isAdhaarValid = regex.adhaarPattern.test(adhaarCardNumber)
            setAdhaarError(isAdhaarValid)
        }
    }, [adhaarCardNumber])

    React.useEffect(() => {
        if (pan) {
            const isPanValid = regex.panPattern.test(pan)
            setPanError(isPanValid)
        }
    }, [pan])

    const [relocation, setRelocation] = React.useState('');
    const [availability, setAvailability] = React.useState('');
    const handleRelocationChange = (event) => {
        setRelocation(event.target.value);
    };

    const [selectedValue, setSelectedValue] = React.useState('a');

    const handleAvailabilityChange = (event) => {
        setAvailability(event.target.value);
    };

    const handleUploadImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        let formData = new FormData();
                        formData.append("file", file);
                        dispatch(uploadImages(formData, (data) => {
                            setImage(data.data.imagesKey[0]);
                        }, (err) => {
                            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
                        }))
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        }
    }

    const handleDeleteSkill = (index) => {
        setAllSkills(prevArray => {
            // Create a new array excluding the item at the specified index
            const newArray = [...prevArray];
            newArray.splice(index, 1);
            return newArray;
        });
    }

    const handleAddAllLanguages = () => {
        if (!languages || !languageLevel) {
            enqueueSnackbar("Please select appropriate language and level before adding", { variant: 'warning' });
        } else {
            setAllLanguages(oldArr => [...oldArr, { language: languages, languageLevel: languageLevel }]);
        }
        setLanguages("");
        setLanguageLevel("");
    }

    const handleDeleteLanguages = (index) => {
        setAllLanguages(prevArray => {
            // Create a new array excluding the item at the specified index
            const newArray = [...prevArray];
            newArray.splice(index, 1);
            return newArray;
        });
    }


    return (
        <>
            <Box py={3}>
                <Box sx={{ backgroundColor: '#F6F8F9', px: { md: 5, xs: 1 }, py: 10, borderRadius: '4px', mx: { md: 5, xs: 1 } }}>
                    <Paper sx={{ mx: { md: 4, xs: 1 }, px: { md: 5, xs: 2 }, pb: 5 }}>
                        <Box py={3} my={2}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Typography variant="h5" sx={{ color: '#000', fontWeight: '600' }}>Personal Details</Typography>
                                </Grid>
                                {/* <Grid item md={2}>
                                    <Button sx={{
                                        backgroundColor: '#2544EE',
                                        borderRadius: '5px',
                                        mx: 5,
                                        px: 5,
                                        float: 'right',
                                        '&:hover': {
                                            backgroundColor: '#FFF',
                                            color: '#2544EE',
                                        },
                                    }}
                                        variant="contained">
                                        <AddIcon /> Add
                                    </Button>
                                </Grid> */}
                            </Grid>
                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item md={2} >
                                <Box py={3} sx={{ backgroundColor: '#F8FAFF', textAlign: 'center', borderRadius: '10px', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                                    {
                                        image != ""
                                            ?
                                            <img
                                                src={image}
                                                style={{ width: '96px', height: '96px', objectFit: 'contain' }}
                                            />
                                            :
                                            <PersonIcon sx={{ color: '#fff', fontSize: '6rem', color: '#2544EE' }} />

                                    }
                                    <Button
                                        variant="contained"
                                        component="label"
                                        my={3}
                                        sx={{ width: '90%', height: '20%', fontSize: "8px", fontWeight: 'bold', backgroundColor: '#2544EE' }}
                                    >
                                        Upload Image
                                        <input
                                            onChange={handleUploadImage}
                                            type="file"
                                            accept=".jpg,.png"
                                            hidden
                                            required
                                        />
                                    </Button>
                                </Box>

                            </Grid>

                            <Grid item md={10}>
                                <p>Profile Image :- Max file size is 1MB, Minimum dimension: 136 x 136 And Suitable files are .jpg & .png</p>
                            </Grid>
                        </Grid>

                        <Grid container my={2}>
                            <Grid item xs={12} md={6}>
                                <InputStyle name="Full Name*" topSpace={true}>
                                    <input type="text" placeholder="Enter Your Name"
                                        value={name}
                                        disabled
                                        onChange={(e) => setName(e.target.value)} />
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputStyle name="Email Address*" topSpace={true}>
                                    <input type="text" placeholder="Enter Your Email"
                                        value={email}
                                        disabled
                                        onChange={(e) => setEmail(e.target.value)} />
                                </InputStyle>
                                {!emailError ? <p style={{ color: 'red', fontWeight: 'bold' }}>Invalid Input</p> : ""}
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Mobile Number*
                                </Typography>
                                <NumberInput isdisabled={true} setCountryCode={setCountryCode} mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Gender
                                </Typography>
                                <Box >

                                    <select className="input-box" name="cars" id="cars"
                                        value={gender}
                                        onChange={(e) => setGender(e.target.value)}>
                                        <option value="">select</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </Box>

                            </Grid>

                            <Grid item xs={12} md={4}>
                                <InputStyle name="Date Of Birth" topSpace={true}>
                                    <input type="date" placeholder="Enter Your Date Of BIrth"
                                        value={dob}
                                        onChange={(e) => setDob(e.target.value)} />
                                </InputStyle>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Skills
                                </Typography>
                                <Box className="profile-skills-box mb-3">
                                    <Grid container>
                                        <Grid item xs={12} md={5}>
                                            <select className="input-box" name="cars" id="cars"
                                                value={skills}
                                                onChange={(e) => setSkills(e.target.value)}>
                                                <option value="">Skills</option>
                                                <option value="Option 1">Option 1</option>
                                                <option value="Option 2">Option 2</option>
                                                <option value="Option 3">Option 3</option>
                                            </select>
                                        </Grid>
                                        <Grid item xs={12} md={5}>
                                            <select className="input-box" name="cars" id="cars"
                                                value={skillLevel}
                                                onChange={(e) => setSkillLevel(e.target.value)}>
                                                <option value="">Level</option>
                                                <option value="Begineer">Begineer</option>
                                                <option value="Experienced">Experienced</option>
                                            </select>
                                        </Grid>
                                        <Grid item md={2}>
                                            <Button variant="contained" style={{ width: '50px' }} onClick={handleAddAllSkills}>
                                                <AddIcon />
                                            </Button>
                                        </Grid>
                                        {
                                            allSkills && allSkills.length > 0
                                                ?
                                                <>
                                                    <Table sx={{ height: '10px' }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>
                                                                    Skill
                                                                </TableCell>
                                                                <TableCell>
                                                                    Skill Level
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                allSkills.map((item, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>
                                                                            {item.skill}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {item.skillLevel}
                                                                        </TableCell>
                                                                        <TableCell><DeleteOutline sx={{ cursor: 'pointer' }} onClick={() => handleDeleteSkill(index)} /></TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </>
                                                :
                                                ""
                                        }
                                    </Grid>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Language
                                </Typography>
                                <Box className="profile-skills-box mb-3">
                                    <Grid container>
                                        <Grid item xs={12} md={5}>
                                            <select className="input-box" name="cars" id="cars"
                                                value={languages}
                                                onChange={(e) => setLanguages(e.target.value)}>
                                                <option value="">Language</option>
                                                <option value="Hindi">Hindi</option>
                                                <option value="English">English</option>
                                            </select>
                                        </Grid>
                                        <Grid item xs={12} md={5}>
                                            <select value={languageLevel} className="input-box" name="cars" id="cars" onChange={(e) => setLanguageLevel(e.target.value)}>
                                                <option value="">Level</option>
                                                <option value="Begineer">Begineer</option>
                                                <option value="Experienced">Experienced</option>
                                            </select>
                                        </Grid>
                                        <Grid item md={2}>
                                            <Button variant="contained" style={{ width: '50px' }} onClick={handleAddAllLanguages}>
                                                <AddIcon />
                                            </Button>
                                        </Grid>
                                        {
                                            allLanguages && allLanguages.length > 0
                                                ?
                                                <>
                                                    <Table sx={{ height: '10px' }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>
                                                                    Language
                                                                </TableCell>
                                                                <TableCell>
                                                                    Language Level
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                allLanguages.map((item, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>
                                                                            {item.language}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {item.languageLevel}
                                                                        </TableCell>
                                                                        <TableCell><DeleteOutline sx={{ cursor: 'pointer' }} onClick={() => handleDeleteLanguages(index)} /></TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </>
                                                :
                                                ""
                                        }
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid container pt={5}>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Nationality" topSpace={true}>
                                    <input type="text" placeholder="Enter Your Nationality"
                                        value={nationality}
                                        onChange={(e) => setNationality(e.target.value)} />
                                </InputStyle>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <InputStyle name="Experience (In Years)" topSpace={true}>
                                    <input type="number" placeholder="Enter Your Experience"
                                        value={experience}
                                        onChange={(e) => setExperience(e.target.value)} />
                                </InputStyle>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <InputStyle name="Career Level" topSpace={true}>
                                    <select className="input-box" name="cars" id="cars"
                                        value={level}
                                        onChange={(e) => setLevel(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="Beginner">Beginner</option>
                                        <option value="Intermediate">Intermediate</option>
                                        <option value="Advanced">Advanced</option>
                                    </select>

                                </InputStyle>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <InputStyle name="Country* " topSpace={true}>
                                    {/* <input type="text" placeholder="Enter Your Country" list="companyList"
                                                    value={country}
                                                    onChange={(e) => setCountry(e.target.value)} /> */}
                                    <select
                                        className="input-box"
                                        type="text"
                                        placeholder="Select Country"
                                        list="countryList"
                                        value={country?.isoCode}
                                        onChange={handleChangeCountry}
                                    >
                                        <option value="">Select</option>
                                        {allCountryList.map((item, index) => (
                                            <option key={index} value={item.isoCode}>{item.name}</option>
                                        ))}
                                    </select>
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="State*" topSpace={true}>
                                    {/* <input type="text" placeholder="Enter Your State"
                                                    value={state}
                                                    onChange={(e) => setState(e.target.value)} /> */}
                                    <select
                                        className="input-box"
                                        type="text"
                                        placeholder="Select State"
                                        list="stateList"
                                        defaultValue={"selectCity"}
                                        disabled={country == "" || country == undefined}

                                        id="selectState"
                                        onChange={handleChangeState}

                                    >
                                        <option>Select</option>
                                        {allStates.map((item, index) => (
                                            <option key={index} value={item.isoCode}>{item.name}</option>
                                        ))}
                                    </select>

                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="City" topSpace={true}>
                                    {/* <input
                                                    value={city}
                                                    onChange={(e) => setCity(e.target.value)}
                                                    placeholder="Enter your city"
                                                    require
                                                /> */}
                                    <select
                                        className="input-box"
                                        type="text"
                                        placeholder="Select City"
                                        list="cityList"
                                        disabled={state == "" || state == undefined}
                                        id="selectCity"
                                        onChange={handleChangeCity}
                                    >
                                        <option value="">Select</option>
                                        {allCities.map((item, index) => (
                                            <option key={index} value={item.name} > {item.name}</option>
                                        ))}
                                    </select>
                                </InputStyle>
                            </Grid>
                        </Grid>

                        <Grid container >
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Pincode" topSpace={true}>
                                    <input type="text" placeholder="Enter Your pincode"
                                        value={pincode}
                                        onChange={(e) => setPincode(e.target.value)} />
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Address
                                </Typography>
                                <Box >

                                    <input
                                        style={{ padding: '1rem 1rem' }}
                                        className="input-box mb-3"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder="Enter your full address"
                                        require
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Bio*
                                </Typography>
                                <JoditEditor
                                    ref={editor}
                                    onChange={(newContent) => setValue(newContent)}
                                    value={value}
                                />
                            </Grid>
                        </Grid>

                        <Grid container style={{ marginTop: '1rem' }}>
                            <Grid item xs={12} md={4}>
                                <FormLabel sx={{ color: '#000' }} className="subHeading2Bold">Availability</FormLabel>
                                <br />
                                <FormControlLabel value="Immediate Available" control={<Radio
                                    checked={availability === 'Immediate Available'}
                                    onChange={handleAvailabilityChange}
                                    value="Immediate Available"
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'Immediate Available' }}
                                />} label="Immediate Available" />
                                <br />
                                <FormControlLabel value="Not Immediate Available" control={<Radio
                                    checked={availability === 'Not Immediate Available'}
                                    onChange={handleAvailabilityChange}
                                    value="Not Immediate Available"
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'Not Immediate Available' }}
                                />} label="Not Immediate Available" />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormLabel sx={{ color: '#000' }} className="subHeading2Bold">Are You Willing to Relocate </FormLabel>
                                <br />
                                <FormControlLabel value="Yes" control={<Radio
                                    checked={relocation === 'Yes'}
                                    onChange={handleRelocationChange}
                                    value="Yes"
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'Yes' }}
                                />} label="Yes" />
                                <br />
                                <FormControlLabel value="No" control={<Radio
                                    checked={relocation === 'No'}
                                    onChange={handleRelocationChange}
                                    value="No"
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'No' }}
                                />} label="No" />
                            </Grid>
                        </Grid>

                        <Button
                            className="text2Mid"
                            sx={{
                                mx: '5',
                                marginTop: '1rem',
                                borderRadius: '2rem',
                                border: '1px solid #2544EE',
                                color: '#2544EE',
                                px: 5,
                                '&:hover': {
                                    backgroundColor: '#FFF',
                                    color: '#2544EE',
                                },
                            }}
                            variant="outlined"
                            component="label"
                        >
                            Upload Resume
                            <input onChange={uploadResume}
                                type="file"
                                hidden
                                accept=".pdf"
                                required />
                        </Button>
                        {!resume
                            ?
                            ""
                            :
                            <>
                                <p style={{ margin: '0.5rem 0rem' }}>{resume.name}
                                    <button style={{ border: 'none', backgroundColor: '#fff', }} onClick={() => (setResume(""))} >
                                        <CloseIcon sx={{ color: '#2544EE' }} />
                                    </button></p>

                            </>

                        }
                        <Typography variant="caption" sx={{ display: 'block', mt: 2 }}>DOC, DOCX, PDF (5MB)</Typography>
                    </Paper>

                    <Paper sx={{ mx: { md: 4, xs: 1 }, my: 3 }}>
                        <Box px={{ md: 5, xs: 1 }} py={3}>
                            <Stack>
                                <Box>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', float: 'left' }}>Social Network</Typography>
                                    {/* <Button mx={5} sx={{
                                        mx: '5',
                                        backgroundColor: '#2544EE',
                                        borderRadius: '5px',
                                        mx: 5,
                                        px: 5,
                                        float: 'right',
                                        '&:hover': {
                                            backgroundColor: '#FFF',
                                            color: '#2544EE',
                                        },
                                    }}
                                        variant="contained">
                                        <AddIcon /> Add
                                    </Button> */}

                                </Box>

                                <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                            </Stack>


                            <Grid container mt={1} spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Typography
                                        component="label"
                                        sx={{
                                            fontWeight: 500,
                                            fontFamily: "Inter",
                                            fontSize: 12,
                                        }}
                                    >
                                        Linkedin
                                    </Typography>
                                    <Box >

                                        <input
                                            style={{ padding: '1rem 1rem' }}
                                            className="input-box mb-3"
                                            value={linkedin}
                                            onChange={(e) => setLinkedin(e.target.value)}
                                            placeholder="Enter your profile url"
                                            require
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Typography
                                        component="label"
                                        sx={{
                                            fontWeight: 500,
                                            fontFamily: "Inter",
                                            fontSize: 12,
                                        }}
                                    >
                                        Portfolio
                                    </Typography>
                                    <Box >

                                        <input
                                            style={{ padding: '1rem 1rem' }}
                                            className="input-box mb-3"
                                            value={portfolio}
                                            onChange={(e) => setPortfolio(e.target.value)}
                                            placeholder="Enter your portfolio link"
                                            require
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>


                    </Paper>

                    <Button mx={5} sx={{
                        mx: '5',
                        backgroundColor: '#2544EE',
                        borderRadius: '2rem',
                        mx: 5,
                        px: 5,
                        '&:hover': {
                            backgroundColor: '#FFF',
                            color: '#2544EE',
                        },
                    }}
                        disabled={loading}
                        onClick={handleSubmit}
                        variant="contained">
                        {
                            loading
                                ?
                                <CircularProgress size={24} />
                                :
                                "Save"
                        }
                    </Button>
                </Box>

            </Box >
        </>
    );
}

export default General;
